export default "__VITE_ASSET__ChUGY75W__"